// extracted by mini-css-extract-plugin
module.exports = {"Tab":"Tab_Tab__2cERP"};